import React, {useEffect, useRef, useState, useCallback} from 'react';
import {useIsFocused, useFocusEffect} from '@react-navigation/native';
import {Animated, Easing, Modal, SafeAreaView} from 'react-native';
import AsyncStorage from '@react-native-async-storage/async-storage';
import TimerBar from '../../TimerBar';
import AudioPlayer from '../../AudioPlayer';
import BreatherElement from './BreatherElement';
import SongList from '../../SongList';
import styled from "styled-components/native";
import Slider from "@react-native-community/slider";

export function AudioCoherenceTraining({endGameCallback, isWorkout}) {
  const [animSpeed, setAnimSpeed] = useState(5000);
  const [delayLength, setDelayLength] = useState(1000);
  const [lastPlayedSong, setLastPlayedSong] = useState(null)
  const [modalVisible, setModalVisible] = useState(false);

  const [songList, setSongList] = useState(null);

  useEffect(() => {
    const fetchLastPlayedSong = async () => {
      try {
        const value = await AsyncStorage.getItem('lastPlayedSong');
        if (value !== null) {
          // Value found in storage
          setLastPlayedSong(value);
        } else {
          // Default value if not found in storage
          setLastPlayedSong('Gamma ocean surf and chimes');
        }
      } catch (error) {
        console.error('Failed to fetch the last played song from AsyncStorage:', error);
        // Optionally set a default value in case of an error
        setLastPlayedSong('Gamma ocean surf and chimes');
      }
    };

    fetchLastPlayedSong();
  }, []);

  function actParentCallback(songListCallback, currentlyPlayingSong) {
    setModalVisible(true);
    const newSongList = <SongList style={{width: "100%", height: "100%", flex: 1}}
                                  callbackFunction={songListCallback} currentlyPlaying={currentlyPlayingSong}/>;
    setSongList(newSongList);
  }

  function closeSongListCallback() {
    setSongList(null);
    setModalVisible(false);
  }

  return (
      <ActParent>

        <Modal
            animationType="slide"
            transparent={false}
            visible={modalVisible}
            onRequestClose={closeSongListCallback}
        >
          <SafeAreaView style={{flex: 1}}>
            {songList}
            {/* <Button title="Close" onPress={closeSongListCallback} /> // This button will close the modal */}
          </SafeAreaView>
        </Modal>
        {isWorkout && (
            <SkipButton
                onPress={() => {
                  endGameCallback({completed: 1});
                }}
            >
              <SkipText>SKIP</SkipText>
            </SkipButton>
        )}
        {lastPlayedSong && (
            <AudioPlayer
                lastPlayedSong={lastPlayedSong}
                callbackFunction={actParentCallback}
                callbackFunctionCloseMenu={closeSongListCallback}
            />
        )}

        <BreatherElement animSpeed={animSpeed} delayLength={delayLength}/>
        <BreatherContainer>
          <BreatherControls>
            <BreatherControlsButtons>
              <BreatherButton
                  style={{backgroundColor: animSpeed <= 3000 ? 'gray' : '#ffcb39'}}
                  disabled={animSpeed <= 3000}
                  onPress={() => {
                    if (animSpeed >= 3000) {
                      setAnimSpeed(animSpeed - 500);
                    }
                  }}
              >
                <ButtonTextMinus>-</ButtonTextMinus>
              </BreatherButton>
              <Slider
                  minimumValue={3000}
                  maximumValue={7000}
                  value={animSpeed}
                  onValueChange={(value) => setAnimSpeed(value)}
                  style={{width: 195, height: 5}}
              />
              <BreatherButton
                  style={{backgroundColor: animSpeed >= 7000 ? 'gray' : '#88cdb2'}}
                  disabled={animSpeed >= 7000}
                  onPress={() => {
                    if (animSpeed <= 7000) {
                      setAnimSpeed(animSpeed + 500);
                    }
                  }}
              >
                <ButtonTextPlus>+</ButtonTextPlus>
              </BreatherButton>
            </BreatherControlsButtons>
          </BreatherControls>
          <BreathingSpeedText>Breathing Speed: The slower the better!</BreathingSpeedText>
        </BreatherContainer>

        {isWorkout && (
            <TimerComponent endGameCallback={endGameCallback}/>
        )}
      </ActParent>
  );
}

export function TimerComponent({endGameCallback}) {
  const [isTimerRunning, setIsTimerRunning] = useState(false);
  const isFocused = useIsFocused();

  const timerCallbackFunction = useCallback(() => {
    endGameCallback({completed: 1});
  }, [endGameCallback]);

  useFocusEffect(
      useCallback(() => {
        setIsTimerRunning(true);

        return () => {
          setIsTimerRunning(false);
        };
      }, [])
  );

  return (
      <>
        {isFocused && isTimerRunning && <TimerBar callbackFunction={timerCallbackFunction} timerLength={120}/>}
      </>
  );
}

export const ActParent = styled.View`
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: white;
  width: 100%;
  height: 100%;
  background: #ffffff;
  padding-bottom: 100px;
  padding-top: 100px;
`;

export const SkipButton = styled.TouchableOpacity`
  position: absolute;
  top: 15px;
  right: 10%;
  width: 57.5px;
  height: 25px;
  border: 1.5px solid #3366CC;
  border-radius: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
`

export const SkipText = styled.Text`
  font-family: 'Montserrat-RG';
  color: #3366CC;
  font-size: 14px;
`

export const BreatherContainer = styled.View`
  position: absolute;
  bottom: 155px;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: auto;
  margin-top: 50px;
`;

export const BreatherControls = styled.View`
  display: flex;
  justify-content: space-around;
  align-items: center;
  width: 100%;
  height: auto;
`

export const BreatherControlsButtons = styled.View`
  width: 300px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: row;
`

export const BreatherButton = styled.TouchableOpacity`
  width: 45px;
  height: 30px;
  border-radius: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
`

export const ButtonTextMinus = styled.Text`
  font-family: 'PresicavHv-RG';
  color: white;
  font-size: 42px;
  margin-top: -12.5px;
  transform: scale(1.35, 1);

`

export const ButtonTextPlus = styled.Text`
  font-family: 'Montserrat-BK';
  color: white;
  font-size: 32px;
  margin-top: -4.5px;
`

export const BreatherControlsSlider = styled.View`
  display: flex;
  justify-content: center;
  align-items: center;

`

export const BreathingSpeedText = styled.Text`
  font-family: 'Montserrat-RG';
  color: #3366CC;
  font-size: 11px;
  text-align: center;
  margin-top: 5px;
  width: 100%;
`;


export default AudioCoherenceTraining;
